import { render } from "./CookiesDialog.vue?vue&type=template&id=5f822c88&ts=true"
import script from "./CookiesDialog.vue?vue&type=script&lang=ts"
export * from "./CookiesDialog.vue?vue&type=script&lang=ts"

import "./CookiesDialog.vue?vue&type=style&index=0&id=5f822c88&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__